import {useEffect, useState} from "react";
import {getUserList} from "../../../../api/user/UserAccountService";
import {getAssets} from "../../../../api/asset/AssetService";
import {getContractList} from "../../../../api/asset/AssetContractService";

const RELATED_PAGEABLE = {page: 0, size: 100, sort: "createdAt", desc: true};

async function fetchRelatedList(request, conditions) {
    try {
        const response = await request(conditions, RELATED_PAGEABLE);
        if (response?.status === 200) {
            return {
                rows: response.data?.content ?? [],
                total: response.data?.totalElements ?? 0,
            };
        }
    } catch {
        /* ignore */
    }
    return {rows: [], total: 0};
}

function useRelatedColumn(request, buildConditions, id) {
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id == null) {
            setRows([]);
            setTotal(0);
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);

        void fetchRelatedList(request, buildConditions(id)).then((result) => {
            if (cancelled) {
                return;
            }
            setRows(result.rows);
            setTotal(result.total);
            setLoading(false);
        });

        return () => {
            cancelled = true;
        };
    }, [id, request, buildConditions]);

    return {rows, total, loading};
}

const buildUserConditions = (companyId) => ({
    company: {id: companyId},
    disable: false,
});

const buildAssetConditions = (companyId) => ({
    company: {id: companyId},
});

const buildContractConditions = (companyId) => ({
    company: {id: companyId},
    dateType: "등록일",
});

export function useCompanyRelatedUserData(id) {
    return useRelatedColumn(getUserList, buildUserConditions, id);
}

export function useCompanyRelatedAssetData(id) {
    return useRelatedColumn(getAssets, buildAssetConditions, id);
}

export function useCompanyRelatedContractData(id) {
    return useRelatedColumn(getContractList, buildContractConditions, id);
}
